/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/provider/provider.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { NgModule } from "@angular/core";
import { ProviderRoutingModule } from "./provider-routing.module";
import * as i0 from "@angular/core";
export class ProviderModule {
    constructor() {
    }
}
ProviderModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    ProviderRoutingModule,
                ],
            },] },
];
/** @nocollapse */
ProviderModule.ctorParameters = () => [];
/** @nocollapse */ ProviderModule.ɵmod = i0.ɵɵdefineNgModule({ type: ProviderModule });
/** @nocollapse */ ProviderModule.ɵinj = i0.ɵɵdefineInjector({ factory: function ProviderModule_Factory(t) { return new (t || ProviderModule)(); }, imports: [[
            ProviderRoutingModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ProviderModule, { imports: [ProviderRoutingModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(ProviderModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ProviderRoutingModule,
                ],
            }]
    }], function () { return []; }, null); })();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvdmlkZXIubW9kdWxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vLi4vdmlzaW9uaWNzL25nL3NyYy9hcHAvcHJvdmlkZXIvcHJvdmlkZXIubW9kdWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsT0FBTyxFQUFDLFFBQVEsRUFBQyxNQUFNLGVBQWUsQ0FBQztBQUN2QyxPQUFPLEVBQUMscUJBQXFCLEVBQUMsTUFBTSwyQkFBMkIsQ0FBQzs7QUFPaEUsTUFBTSxPQUFPLGNBQWM7SUFDekI7SUFBZSxDQUFDOzs7WUFOakIsUUFBUSxTQUFDO2dCQUNSLE9BQU8sRUFBRztvQkFDUixxQkFBcUI7aUJBQ3RCO2FBQ0Y7Ozs7a0RBQ1ksY0FBYzsyR0FBZCxjQUFjLGtCQUpmO1lBQ1IscUJBQXFCO1NBQ3RCO3dGQUVVLGNBQWMsY0FIdkIscUJBQXFCO2tEQUdaLGNBQWM7Y0FMMUIsUUFBUTtlQUFDO2dCQUNSLE9BQU8sRUFBRztvQkFDUixxQkFBcUI7aUJBQ3RCO2FBQ0YiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge05nTW9kdWxlfSBmcm9tIFwiQGFuZ3VsYXIvY29yZVwiO1xuaW1wb3J0IHtQcm92aWRlclJvdXRpbmdNb2R1bGV9IGZyb20gXCIuL3Byb3ZpZGVyLXJvdXRpbmcubW9kdWxlXCI7XG5cbkBOZ01vZHVsZSh7XG4gIGltcG9ydHMgOiBbXG4gICAgUHJvdmlkZXJSb3V0aW5nTW9kdWxlLFxuICBdLFxufSlcbmV4cG9ydCBjbGFzcyBQcm92aWRlck1vZHVsZSB7XG4gIGNvbnN0cnVjdG9yKCkge31cbn1cbiJdfQ==